import { BASE, COLOR, JARGON, KIND, LAYOUT, TAB } from "../../modules/constants"
import HOOK from "../hooks"
import React from "react"
import addToMenu from "./addToMenu"
import { Box, Divider } from "@mui/material"

// The Company/Person (Nexus) pages show these same filter group headings without their tooltip
const noHeaderTooltip = item => ({ ...item, text: { ...item.text, tooltipTitle: undefined } })

const getCheckboxMenu = props => {
  // console.log('mapMenuItems props:',props)
  var items = getMenuItems(props)
  // console.log('items:', items)

  return items.map(({ divider, dontColorUnchecked, hooks, text, viewButtons }, index) => (
    <React.Fragment key={index} >
      {index === 0 && props.kind === KIND.LSE.ADVISERS && (
        <Box component="strong" sx={{ display: 'block', mt: 1 }}>
          Filter by Client
        </Box>
      )}
      {
        text && addToMenu({
          ...props,
          index,
          hooks,
          text,
          dontColorUnchecked,
        })
      }
      {
        hooks && addToMenu({
          ...props,
          index,
          hooks,
          dontColorUnchecked,
        })
      }
      {
        viewButtons && addToMenu({
          ...props,
          index,
          viewButtons,
        })
      }
      {
        divider && <Divider sx={divider} />
      }
    </React.Fragment>
  ))
}

// Uses switch to collect the checkboxes for the given tab and kind (radio button selection)
export const getMenuItems = props => {
  // console.log('menuItems props:', props)
  const { handleChangeView, kind, nexusView, portrait, showSecondDegree, tabIndex } = props

  switch (tabIndex) {
    //#region LSE tabs

    // LSE Dashboard
    case TAB[BASE.DASHBOARD].INDEX:
      return [
        noHeaderTooltip(indexAndFavourite),
        companyType,
        noHeaderTooltip(newsCategory),
      ]

    // LSE Companies
    case TAB[BASE.LSE.COMPANIES].INDEX:
      // Switch on selected radio button
      switch (kind) {

        case KIND.LSE.COMPANIES.OVERVIEW:
        case KIND.LSE.COMPANIES.BOARD:
        case KIND.LSE.COMPANIES.GOVERNANCE:
        case KIND.LSE.COMPANIES.DATES:
        case KIND.LSE.COMPANIES.ADVISERS:
          return [
            noHeaderTooltip(indexAndFavourite),
            companyType,
            noHeaderTooltip(country),
            noHeaderTooltip(industry),
          ]

        case KIND.LSE.COMPANIES.COMMITTEES:
          return [
            noHeaderTooltip(indexAndFavourite),
            companyType,
            noHeaderTooltip(country),
            noHeaderTooltip(industry),
            committee
          ]

        default:
          throw new Error(`Kind '${kind}' is not recognised for LSE Companies tab`)
      }

    // LSE Roles
    case TAB[BASE.LSE.ROLES].INDEX:
      switch (kind) {

        case KIND.LSE.ROLES.BOARD:
          return [
            noHeaderTooltip(lseIndex),
            companyType,
            noHeaderTooltip(country),
            noHeaderTooltip(tense),
            noHeaderTooltip(sex),
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
            noHeaderTooltip(industry),
          ]

        case KIND.LSE.ROLES.COMMITTEES:
          return [
            noHeaderTooltip(lseIndex),
            companyType,
            noHeaderTooltip(country),
            noHeaderTooltip(sex),
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
            committee,
            noHeaderTooltip(industry),
          ]

        default:
          throw new Error(`Kind '${kind}' is not recognised for LSE Roles tab`)
      }

    // LSE People
    case TAB[BASE.LSE.PEOPLE].INDEX:
      switch (kind) {

        case KIND.LSE.PEOPLE.BOARD:
          return [
            noHeaderTooltip(lseIndex),
            companyType,
            noHeaderTooltip(tense),
            noHeaderTooltip(sex),
          ]

        case KIND.LSE.PEOPLE.COMMITTEES:
          return [
            noHeaderTooltip(lseIndex),
            companyType,
            noHeaderTooltip(sex),
            committee,
          ]

        default:
          throw new Error(`Kind '${kind}' is not recognised for LSE People tab`)
      }

    case TAB[BASE.LSE.ADVISERS].INDEX:
      return [
        noHeaderTooltip(indexAndFavourite),
        companyType,
        noHeaderTooltip(country),
        noHeaderTooltip(industry),
      ]

    // LSE News
    case TAB[BASE.LSE.NEWS].INDEX:
      return [
        noHeaderTooltip(indexAndFavourite),
        companyType,
        noHeaderTooltip(newsCategory),
      ]
    //#endregion

    //#region nexus
    // Company
    case TAB[BASE.COMPANY].INDEX:
      switch (kind) {
        case KIND.NEXUS.COMPANY.DASHBOARD:
          return []
        case KIND.NEXUS.COMPANY.BOARD:
          return [
            // In portrait, the view buttons (and the divider that separated them from these filters) are
            // rendered separately above the table, not in this menu
            ...(portrait ? [] : [view({ handleChangeView, nexusView }), divider('16px')]),
            noHeaderTooltip(tense),
            noHeaderTooltip(sex),
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]
        case KIND.NEXUS.COMPANY.CONNECTIONS:
          return [
            // In portrait, the view buttons (and the divider that separated them from these filters) are
            // rendered separately above the table, not in this menu
            ...(portrait ? [] : [view({ handleChangeView, nexusView }), divider('16px')]),
            noHeaderTooltip(tense),
            noHeaderTooltip(sex),
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]
        case KIND.NEXUS.COMPANY.COMMITTEES:
          return [
            noHeaderTooltip(sex),
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]
        case KIND.NEXUS.COMPANY.NEWS:
          return [
            noHeaderTooltip(newsCategory),
          ]
        case KIND.NEXUS.COMPANY.ADVISER_CLIENTS:
          return [
            noHeaderTooltip(indexAndFavourite),
            companyType,
            noHeaderTooltip(country),
            noHeaderTooltip(industry),
          ]

        default:
          throw new Error(`Kind '${kind}' is not recognised for Company tab`)
      }
    // Person
    case TAB[BASE.PERSON].INDEX:
      switch (kind) {
        case KIND.NEXUS.PERSON.ROLES:
          return [
            personTitle(showSecondDegree),
            // In portrait, the view buttons (and the divider that separated them from these filters) are
            // rendered separately above the table, not in this menu
            ...(portrait ? [] : [view({ handleChangeView, nexusView }), divider('16px')]),
            noHeaderTooltip(tense),
            noHeaderTooltip(indexAndOther),
            companyType,
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]

        case KIND.NEXUS.PERSON.CONNECTIONS:
          return [
            personTitle(showSecondDegree),
            // In portrait, the view buttons (and the divider that separated them from these filters) are
            // rendered separately above the table, not in this menu
            ...(portrait ? [] : [view({ handleChangeView, nexusView }), divider('16px')]),
            noHeaderTooltip(tense),
            noHeaderTooltip(indexAndOther),
            companyType,
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]

        case KIND.NEXUS.PERSON.COMMITTEES:
          return [
            {
              text: { text: "COMMITTEE ROLES" },
            },
            noHeaderTooltip(indexAndOther),
            companyType,
            noHeaderTooltip(boardRole),
            noHeaderTooltip(executive),
            noHeaderTooltip(independent),
          ]

        case KIND.NEXUS.PERSON.NEWS:
          return [] // No checkboxes for person news

        default:
          throw new Error(`Kind ${kind} is not recognised for Person tab`)
      }
    //#endregion nexus

    case TAB[BASE.NEWS_RELEASE].INDEX:
      return []

    case TAB[BASE.LSE.ADVISERS].INDEX:
      return []

    default:
      throw new Error(`TabIndex '${tabIndex}' is not recognised`)
  }
}

//#region checkbox menu items
const lseIndex = {
  hooks: [HOOK.LSE_INDEX],
  text: {
    text: JARGON.LSE_GROUP,
    tooltipTitle: JARGON.LSE_GROUP_TT,
  }
}

const indexAndFavourite = {
  ...lseIndex,
  hooks: [...lseIndex.hooks, HOOK.FAVOURITE],
}

const indexAndOther = {
  ...lseIndex,
  hooks: [...lseIndex.hooks, HOOK.OTHER_INDEX],
}

const companyType = {
  hooks: [HOOK.COMPANY_TYPE],
  text: {
    text: JARGON.LSE_COMPANY_TYPE,
  }
}

const country = {
  hooks: [HOOK.COUNTRY],
  text: {
    text: `Country of Incorporation`,
    tooltipTitle: "country where company was incorporated"
  }
}

const industry = {
  hooks: [HOOK.INDUSTRY],
  text: {
    text: JARGON.ICB_INDUSTRY,
    tooltipTitle: `${JARGON.ICB_INDUSTRY} classification of company`
  },
}

const executive = {
  hooks: [HOOK.EXEC],
  text: {
    text: `${JARGON.EXEC}`, // Executive role?
    tooltipTitle: "role is executive"
  },
}

const sex = {
  hooks: [HOOK.SEX],
  text: {
    text: JARGON.SEX,
    tooltipTitle: "gender of director or officer"
  },
}

const independent = {
  hooks: [HOOK.INDP],
  text: {
    text: `${JARGON.INDEPENDENT}`, // independent role?
    tooltipTitle: "role is independent"
  },
}

const committee = {
  hooks: [HOOK.COMMITTEE],
  text: {
    text: JARGON.COMMITTEE_ROLES,
  },
}

const newsCategory = {
  hooks: [HOOK.NEWS_CATEGORY],
  text: {
    text: "News Category",
    tooltipTitle: "News Release Categories"
  },
}

const tense = {
  hooks: [HOOK.TENSE],
  text: {
    text: `${JARGON.APPT} ${JARGON.TENSE.Status}`,
    tooltipTitle: "status of director or officer role"
  },
}

const boardRole = {
  hooks: [HOOK.POSITION],
  text: {
    text: `${JARGON.ROLE} Type`,
    tooltipTitle: "role type of director or officer"
  },
}

// Unlike tense, committee etc, const view is a function because we need to pass props into it
const view = ({ handleChangeView, nexusView }) => ({
  text: {
    text: "View",
  },
  viewButtons: {
    nexusView,
    handleChangeView,
  },
})

const divider = marginTop => (
  {
    // mr matches the menu's own left padding, so the line is inset by the same amount on both ends
    divider: { mt: marginTop, mr: `${LAYOUT.COLUMN_PADDING}px`, borderBottomWidth: '1px', borderColor: COLOR.VERY_LIGHT_GREY }
  }
)
//#endregion

const personTitle = showSecondDegree => ({
  text: {
    text: showSecondDegree ? "CO-DIRECTORS" : "UK BOARD ROLES",
  },
})

export default getCheckboxMenu


